<script>
    import { onMount } from "svelte";
    import Fa from "svelte-fa";
    import { faPlus } from "@fortawesome/free-solid-svg-icons";
    import Period from "./Period.svelte";

    export let periods;
    export let name;
    export let day;
    let active;

    $: myPeriods = periods.filter(period => period.open?.day == day)??[];
    $: active = myPeriods.length>0;

    onMount(() => {
        // Set day to active if any periods exist for it
        if (myPeriods.length > 0) {
            active = true;
        }
    });

    function addPeriod() {
        periods.push({open: {day, time: "0900"}, close: {day, time: "1800"}});
        periods = periods;
    }

    function deletePeriod(e) {
        console.log(e.detail.period);
        periods = periods.filter(period => period != e.detail.period);
        periods = periods;
    }

    function onToggle() {
        if (myPeriods.length == 0) {
            // add a period for this day
            addPeriod();
        } else {
            // delete periods associated with this day
            periods = periods.filter(period => period.open?.day != day);
            periods = periods;
        }
    }
</script>

<div class="container">
    <input bind:checked={active} type="checkbox" class="checkbox" id={name} on:change={onToggle}>
    <label for={name} class="day noselect">{name}</label>
    {#if myPeriods.length>0}
        <div class="periods">
            {#each myPeriods as period}
            <Period bind:period on:delete={deletePeriod}/>
            {/each}
        </div>
    {:else}
        <i class="closed">geschlossen</i>
    {/if}
    <button on:click={addPeriod} class="new"><Fa icon={faPlus} /></button>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: [checkbox] 2rem [day] 12ch [slots] auto [new] 2rem [end];
        grid-template-rows: auto;
        margin-bottom: 1rem;
    }

    .noselect {
        -webkit-user-select: none; /* Safari */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    }

    .checkbox {
        grid-area: checkbox;
        margin-bottom: 0;
        width: 1.5rem;
        height: 1.5rem;
    }

    .day {
        grid-area: day;
    }

    .periods {
        grid-area: slots;
    }
    
    .new {
        grid-area: new;
    }

    .closed {
        grid-area: slots;
    }
</style>